import _ from 'lodash';
import { NEUTRAL_SEVERITY } from '../../constants';

export default (alarmRanges, enumeration) => _.some(alarmRanges)
  ? _.map(alarmRanges, range => range.severity)
  : enumeration
    ? _.map(enumeration.states, _.constant(NEUTRAL_SEVERITY))
    : null;